import React from 'react';
import { Container, Box } from '@mui/material';
import { SignUpForm } from '../../components/auth/SignUpForm';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export const SignUp: React.FC = () => {
  const { state } = useAuth();

  if (state.user) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 4, sm: 8 },
          pb: { xs: 6, sm: 12 },
        }}
      >
        <SignUpForm />
      </Box>
    </Container>
  );
};

export default SignUp;
